
@if (isDisconnect) {

  <div class="disconnect-modal">
    <div class="disconnect-container">
      <div class="disconnect-body">
        <!--<div class="flex items-center justify-center mb-4 ">
          <svg class="w-12 h-12 text-yellow-500" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" d="M12 8v4m0 4h.01M12 2a10 10 0 11-10 10A10 10 0 0112 2z"/>
          </svg>
        </div>-->
        <h2 class="text-2xl font-semibold text-gray-800 mb-2">Servicio en Mantenimiento</h2>
        <p class="text-gray-600 mb-4">Estamos realizando tareas de mantenimiento. Por favor, intenta ingresar más tarde.</p>
        <p class="text-sm text-gray-400">Gracias por tu comprensión.</p>
      </div>
    </div>


  </div>
}

<app-loading/>


<router-outlet></router-outlet>
@if (isSpinnerVisible) {
  <mat-progress-bar class="loader" mode="indeterminate" value="50"></mat-progress-bar>
}




